import {
  SET_BOOKING,
  EVENT_BOOKINGS,
  CALENDAR_EVENTS_LOADED,
  CALENDAR_HOMES_LOADED,
  CALENDAR_LOADING,
} from "../../actions/types";

const initialState = {
  bookings: [],
  homeBookingEvents: [],
  events: [],
  loading: true,
  homes: [],
};

const bookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BOOKING:
      return { ...state, bookings: action.booking };
    case EVENT_BOOKINGS:
      return {
        ...state,
        homeBookingEvents: action.payload,
      };
    case CALENDAR_LOADING:
      return { ...state, loading: true };
    case CALENDAR_EVENTS_LOADED:
      return { ...state, events: action.payload, loading: false };
    case CALENDAR_HOMES_LOADED:
      return { ...state, homes: action.payload };
    default:
      return state;
  }
};

export default bookingReducer;
